import { AsideAdmin } from '../AsideAdmin'
import { HeaderAdmin } from '../HeaderAdmin'
import * as S from './styles'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../App'
import { getCliquesWhats } from '../../../shared/redux/slices/loja'
import { getWhats as getWhatsSelector } from '../../../shared/redux/selectors'
import { Select, Table } from 'antd'
import { Whats } from '../../../shared/types'

export const WhatsApp = () => {
    const dispatch = useDispatch<AppDispatch>()
    const whats = useSelector(getWhatsSelector)
    const [list, setList] = useState<any>()
    const [listFilter, setListFilter] = useState<any>()
    const anos = [];
      const anoAtual = new Date().getFullYear();
    
      for (let ano = anoAtual; ano >= 2023; ano--) {
        anos.push(ano);
      }
      const AnosData = anos?.map((x, i) => {
        return {
            key: i,
            label: x,
            value: x
        }
      })

    useEffect(()=>{
        dispatch(getCliquesWhats())
    },[])

    useEffect(()=> {
        const result = whats?.map((x, i) => {
            const [dateString] = x.data?.split(' ');
            const retorno = {
                ip: x.ip,
                data: dateString,
                key: i
            }
            return retorno
        })
        setListFilter(result)
        setList(result)
    },[whats])
      
      const columns = [
        {
          title: 'IP',
          dataIndex: 'ip',
          key: 'ip',
        },
        {
          title: 'Data',
          dataIndex: 'data',
          key: 'data',
        },
      ];

      const handleChangeMes = (value: string) => {
        const filter = list.map((x: Whats) => {
            const date = x.data?.split('-')[1]
            if(date === value) {
                return x
            }
        }).filter(Boolean)
        setListFilter(filter)
      };
      const handleChangeAno = (value: string) => {
        const filter = list.map((x: Whats) => {
            const date = x.data?.split('-')[0]
            if(date === value.toString()) {
                return x
            }
        }).filter(Boolean)
        setListFilter(filter)
      };

      useEffect(() => {
        const filter = list?.map((x: Whats) => {
          const date = x.data?.split('-')[0]
          if(date === Number(new Date().getFullYear()).toString()) {
              return x
          }
      }).filter(Boolean)
      setListFilter(filter)
      },[whats])

      

    return (
        <S.Container>
            <AsideAdmin />
            <HeaderAdmin />
            <div className='title'>
                <i className="ri-whatsapp-line ri-3x"></i>
                <h1>WhatsApp</h1>
            </div>
            <h2>Total de registros do mês selecionado : {listFilter?.length}</h2>
            <h4>Filtrar registros pelo mês e ano:</h4>
            <div style={{display: "flex", flexDirection: "row", gap: 20}}>
                <Select
                    defaultValue="Selecione o mês"
                    style={{ width: 300 }}
                    onChange={handleChangeMes}
                    options={[
                        { value: '00', label: 'Selecione o mês' },
                        { value: '01', label: 'Janeiro' },
                        { value: '02', label: 'Fevereiro' },
                        { value: '03', label: 'Março' },
                        { value: '04', label: 'Abril' },
                        { value: '05', label: 'Maio' },
                        { value: '06', label: 'Junho' },
                        { value: '07', label: 'Julho' },
                        { value: '08', label: 'Agosto' },
                        { value: '09', label: 'Setembro' },
                        { value: '10', label: 'Outubro' },
                        { value: '11', label: 'Novembro' },
                        { value: '12', label: 'Dezembro' },
                    ]}
                />
                <Select
                    defaultValue="Selecione o ano"
                    style={{ width: 300 }}
                    onChange={handleChangeAno}
                    options={AnosData}
                />
            </div>
            <Table dataSource={listFilter} columns={columns} />
        </S.Container>
    )
}